module.exports = __webpack_public_path__ + "img/5_18.80549b4d.png";